import Service from './Service';

/**
 * Classe utilizada para tratar regras de negócio e manipular o retorno dos webservices
 */
class FaixaEtariaService extends Service {
  async consultarFaixas (idade) {
    let faixas = [];
    const brancoAcoes = '';
    let result = await this.getFaixaEtariaApi().consultarFaixas(idade);
    result.map(res => {
      const { seqIdade, idadeInicio, idadeFim, indAtivo } = res;
      faixas.push(Object.values({ seqIdade, idadeInicio, idadeFim, indAtivo, brancoAcoes }));
    });
    return faixas || [];
  }
  async consultarFaixasEtariasSelect () {
    let faixas = await this.getFaixaEtariaApi().consultarFaixas(0);
    return faixas || [];
  }
  async incluirFaixa (faixa) {
    let result = await this.getFaixaEtariaApi().incluirFaixa(faixa);
    return result;
  }
  async excluirFaixa (seqIdade) {
    let result = await this.getFaixaEtariaApi().excluirProfissional(seqIdade);
    return result;
  }
  async alterarFaixa (faixa) {
    let result = await this.getFaixaEtariaApi().alterarFaixa(faixa);
    return result;
  }
  async validarFaixa (faixa, indInclusao) {
    const result = await this.getFaixaEtariaApi().validarFaixa(faixa, indInclusao);
    return result;
  }
}
export default FaixaEtariaService;
